import { ClientLocaleNS } from 'lib/constants/locales'
import { FC } from 'react'
import { TermsBlock } from './components/TermsBlock/TermsBlock'
import { CookiesBlock } from './components/CookiesBlock/CookiesBlock'

type TProps = {}

// number of list elements
const TERMS_CONTENT = [0, 3, 2, 1, 1, 1, 1]
const PRIVACY_CONTENT = [0, 3, 2, 1, 1, 1, 1, 1, 1]
const COOKIES_CONTENT = [2, 4, 3, 6, 0]

const TermsPageContent: FC<TProps> = () => {
  return (
    <div className="flex flex-1 flex-col gap-20 py-20">
      <TermsBlock contentMap={TERMS_CONTENT} ns={ClientLocaleNS.TermsPage} />
      <TermsBlock contentMap={PRIVACY_CONTENT} ns={ClientLocaleNS.PrivacyPage} />
      <CookiesBlock contentMap={COOKIES_CONTENT} ns={ClientLocaleNS.CookiePage} />
    </div>
  )
}

export { TermsPageContent }
